import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createProducto, getProductos, deleteProducto } from "../services/productoService";
import { componenteService } from "../services/componenteService";
import { ensureArray } from "../utils/plantillas";
import { formatNumber } from "../utils/numberFormat";

export default function Productos() {
    const navigate = useNavigate();

    const [productos, setProductos] = useState([]);
    const [componentesDisponibles, setComponentesDisponibles] = useState([]);

    const [nuevoProducto, setNuevoProducto] = useState({
        nombre: "",
        porcentajeGanancia: "",
        componentes: [],
        servicios: []
    });

    const [modalComp, setModalComp] = useState(null);

    const safeArr = (arr, name) => {
        if (!Array.isArray(arr)) {
            if (arr !== undefined && arr !== null) console.warn(`${name} expected array but got:`, arr);
            return [];
        }
        return arr;
    };

    const [nuevoServicio, setNuevoServicio] = useState({ nombre: "", costo: "" });

    useEffect(() => {
        cargarProductos();
        cargarComponentes();
    }, []);

    const cargarComponentes = async () => {
        try {
            const categorias = [
                "gabinete",
                "puerta",
                "accesorio",
                "materialesFrio",
                "materialesElectricos",
                "unidadCondensadora",
                "evaporadorCubico"
            ];

            const todas = [];
            for (let c of categorias) {
                const res = await componenteService[c].getAll();
                // en lugar de filtrar, agregamos tal cual para permitir seleccionar cualquier componente creado
                res.forEach(r => todas.push(r));
            }

            // No deduplicamos aquí: el usuario quiere poder seleccionar cualquiera de los componentes creados
            setComponentesDisponibles(todas);

        } catch (err) {
            console.error(err);
        }
    };

    const cargarProductos = async () => {
        try {
            const data = await getProductos();
            setProductos(data);
        } catch (err) {
            console.error(err);
        }
    };

    const seleccionarComponente = (e) => {
        const id = e.target.value;
        if (!id) return;
        const comp = componentesDisponibles.find(c => c.id === Number(id));
        if (!comp) return;
        setNuevoProducto(prev => ({
            ...prev,
            componentes: [...prev.componentes, comp]
        }));
    };

    const verDetalle = (comp) => {
        // normalize items before showing modal to avoid runtime .map errors
        const normalized = { ...comp, items: ensureArray(comp.items) };
        setModalComp(normalized);
    };

    const cerrarModal = () => setModalComp(null);

    const agregarServicio = () => {
        if (!nuevoServicio.nombre || !nuevoServicio.costo) {
            alert("Complete el servicio");
            return;
        }
        setNuevoProducto(prev => ({
            ...prev,
            servicios: [...prev.servicios, { ...nuevoServicio, costo: Number(nuevoServicio.costo) }]
        }));
        setNuevoServicio({ nombre: "", costo: "" });
    };

    const eliminarComponente = (i) => {
        setNuevoProducto(prev => ({
            ...prev,
            componentes: prev.componentes.filter((_, idx) => idx !== i)
        }));
    };

    const eliminarServicio = (i) => {
        setNuevoProducto(prev => ({
            ...prev,
            servicios: prev.servicios.filter((_, idx) => idx !== i)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                nombre: nuevoProducto.nombre.trim(),
                porcentajeGanancia: Number(nuevoProducto.porcentajeGanancia),
                componentes: nuevoProducto.componentes.map(c => c.id),
                servicios: nuevoProducto.servicios
            };

            await createProducto(payload);
            alert("Producto creado correctamente");
            setNuevoProducto({
                nombre: "",
                porcentajeGanancia: "",
                componentes: [],
                servicios: []
            });
            cargarProductos();

        } catch (err) {
            console.error(err);
            alert("Error al crear producto");
        }
    };

    const eliminarProducto = async (id) => {
        if (!window.confirm("¿Seguro que querés eliminar este producto?")) return;
        await deleteProducto(id);
        cargarProductos();
    };

    return (
        <div className="productos-container">
            <h2>Crear nuevo producto</h2>

            <form onSubmit={handleSubmit} className="crear-producto-form">

                <label>Nombre del producto</label>
                <input
                    name="nombre"
                    value={nuevoProducto.nombre}
                    onChange={(e) => setNuevoProducto(prev => ({ ...prev, nombre: e.target.value }))}
                />

                <label>Porcentaje de ganancia (%)</label>
                <input
                    type="number"
                    name="porcentajeGanancia"
                    value={nuevoProducto.porcentajeGanancia}
                    onChange={(e) => setNuevoProducto(prev => ({ ...prev, porcentajeGanancia: e.target.value }))}
                />

                <h3>Componentes (con ganancia)</h3>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <select className="border p-2" onChange={seleccionarComponente} style={{ flex: 1, minWidth: 320 }}>
                        <option value="">Seleccionar componente...</option>
                        {safeArr(componentesDisponibles, 'componentesDisponibles').map((c) => (
                            <option key={`${c.id}-${c.type}-${c.nombre}`} value={c.id}>
                                {`[${c.type}] ${c.nombre} (id:${c.id}) — $${formatNumber(c.costoTotal || 0)}`}
                            </option>
                        ))}
                    </select>
                    <div style={{ minWidth: 260 }}>
                        <small style={{ color: '#666' }}>Seleccioná y luego repetí para añadir más componentes</small>
                    </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 12, marginTop: 8 }}>
                    {safeArr(nuevoProducto.componentes, 'nuevoProducto.componentes').map((c, i) => (
                        <div key={i} style={{ border: '1px solid #e5e7eb', padding: 10, borderRadius: 6, position: 'relative', cursor: 'pointer' }} onClick={() => verDetalle(c)}>
                            <div style={{ fontWeight: 'bold' }}>[{c.type}] {c.nombre}</div>
                            <div style={{ color: '#111', marginTop: 6 }}>${formatNumber(c.costoTotal || 0)}</div>
                            <div style={{ position: 'absolute', top: 8, right: 8 }}>
                                <button type="button" onClick={(e) => { e.stopPropagation(); eliminarComponente(i); }} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '4px 8px', borderRadius: 4 }}>✕</button>
                            </div>
                        </div>
                    ))}

                {modalComp && (
                    <div>
                        {/* lazy import modal component to avoid extra imports at top */}
                        <React.Suspense fallback={null}>
                            {/* We can import the modal dynamically, but here just render inline using the same structure */}
                            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <div style={{ background: 'white', borderRadius: 8, maxWidth: 900, width: '95%', padding: 20, boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                        <h3 style={{ margin: 0 }}>{modalComp.nombre} <small style={{ color: '#666', marginLeft: 8 }}>[{modalComp.type || modalComp.tipo || '—'}]</small></h3>
                                        <button onClick={cerrarModal} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '6px 10px', borderRadius: 6 }}>Cerrar</button>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 260px', gap: 20 }}>
                                        <div>
                                            <h4>Ítems</h4>
                                            {Array.isArray(modalComp.items) && modalComp.items.length > 0 ? (
                                                <table className="table" style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr><th>Nombre</th><th>Costo</th></tr>
                                                    </thead>
                                                    <tbody>
                                                        {modalComp.items.map((it, idx) => (
                                                            <tr key={idx}><td>{it.nombre}</td><td>${formatNumber(it.costo)}</td></tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div>
                                                    <p style={{ color: '#666' }}>No hay ítems registrados.</p>
                                                    {modalComp.items && console.warn('modalComp.items is not an array:', modalComp.items)}
                                                </div>
                                            )}
                                        </div>
                                        <aside style={{ borderLeft: '1px solid #eee', paddingLeft: 12 }}>
                                            <h4>Metadatos</h4>
                                            <div><strong>Nombre</strong>: {modalComp.nombre}</div>
                                            <div><strong>Tipo</strong>: {modalComp.type || modalComp.tipo || '—'}</div>
                                            <div><strong>Items</strong>: {modalComp.items?.length || 0}</div>
                                        </aside>
                                    </div>
                                </div>
                            </div>
                        </React.Suspense>
                    </div>
                )}
                </div>

                <h3>Servicios (sin ganancia)</h3>
                <div className="item-row">
                    <input
                        type="text"
                        placeholder="Servicio"
                        value={nuevoServicio.nombre}
                        onChange={(e) =>
                            setNuevoServicio(prev => ({ ...prev, nombre: e.target.value }))
                        }
                    />
                    <input
                        type="number"
                        placeholder="Costo"
                        value={nuevoServicio.costo}
                        onChange={(e) =>
                            setNuevoServicio(prev => ({ ...prev, costo: e.target.value }))
                        }
                    />
                    <button type="button" onClick={agregarServicio} className="bg-blue-600 text-white px-3 rounded">
                        + Servicio
                    </button>
                </div>

                {safeArr(nuevoProducto.servicios, 'nuevoProducto.servicios').map((s, i) => (
                    <div key={i} className="item-row">
                        🔧 {s.nombre} — ${formatNumber(s.costo)}
                        <button type="button" onClick={() => eliminarServicio(i)}>✕</button>
                    </div>
                ))}

                <button type="submit" className="crear-btn">Crear producto</button>
            </form>

            {/* LISTA DE PRODUCTOS */}
            <div style={{ marginTop: 24 }}>
                <h2 style={{ marginBottom: 12 }}>Lista de productos</h2>

                {safeArr(productos, 'productos').length === 0 ? (
                    <p>No hay productos</p>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '2px solid #e8e8e8' }}>Nombre</th>
                                    <th style={{ textAlign: 'right', padding: '10px 12px', borderBottom: '2px solid #e8e8e8' }}>Costo Total</th>
                                    <th style={{ textAlign: 'center', padding: '10px 12px', borderBottom: '2px solid #e8e8e8' }}>Ganancia (%)</th>
                                    <th style={{ textAlign: 'right', padding: '10px 12px', borderBottom: '2px solid #e8e8e8' }}>Ganancia ($)</th>
                                    <th style={{ textAlign: 'center', padding: '10px 12px', borderBottom: '2px solid #e8e8e8' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {safeArr(productos, 'productos').map((p, idx) => (
                                    <tr key={p.id} style={{ background: idx % 2 === 0 ? '#fff' : '#fbfbfb' }}>
                                        <td style={{ padding: '10px 12px' }}>{p.nombre}</td>
                                        <td style={{ padding: '10px 12px', textAlign: 'right' }}>${formatNumber(p.costoTotal || 0)}</td>
                                        <td style={{ padding: '10px 12px', textAlign: 'center' }}>{p.porcentajeGanancia}%</td>
                                        <td style={{ padding: '10px 12px', textAlign: 'right' }}>${formatNumber(p.gananciaGenerada || 0)}</td>
                                        <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                                            <button onClick={() => navigate(`/productos/${p.id}`)} style={{ marginRight: 8 }}>Ver detalle</button>
                                            <button onClick={() => eliminarProducto(p.id)} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '6px 8px', borderRadius: 4 }}>Eliminar</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
